import { specialProfileQuery } from '#pplx/frontend/apps/ask/queries/user-queries/specialProfileQuery.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
export function useSpecialProfileQuery(profileName, reason) {
    return useQuery(specialProfileQuery.getOptions({ reason }, { profileName }, { enabled: !!profileName }));
}
//# sourceMappingURL=useSpecialProfileQuery.js.map